import api from "./api";

export const createSmartContract = async (shipmentId) => {
    const res = await api.post(`/smartcontract/create/${shipmentId}`);
    return res.data;
};

export const getSmartContracts = async () => {
    const res = await api.get("/smartcontract");
    return res.data;
};

export const getSmartContractById = async (id) => {
    const res = await api.get(`/smartcontract/${id}`);
    return res.data;
};

export const getSmartContractByShipmentId = async (shipmentId) => {
    const res = await api.get(`/smartcontract/shipment/${shipmentId}`);
    return res.data;
};

export const addSmartContractClause = async (contractId, payload) => {
    const res = await api.post(`/smartcontract/${contractId}/clause`, payload);
    return res.data;
};
export const getClientSmartContractByShipmentId = async (shipmentId) => {
    return getSmartContractByShipmentId(shipmentId);
};
export const updateSmartContractStatus = async (contractId, payload) => {
    const res = await api.put(`/smartcontract/${contractId}/status`, payload);
    return res.data;
};

export default {
    createSmartContract,
    getSmartContracts,
    getSmartContractById,
    getSmartContractByShipmentId,
    addSmartContractClause,
    updateSmartContractStatus,
    getClientSmartContractByShipmentId,
};